module.exports = __webpack_public_path__ + "static/media/pending_order_delivery.aa25b0b6.svg";